import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import Assessment from './Assessment.component';

const AssessmentQualificationPage: React.FC = () => {
  const processTypeStringId = AssessmentSessionProcessTypeId.Qualification.toString();
  const processTypeId = parseInt(processTypeStringId) as AssessmentSessionProcessTypeId;

  return <Assessment processTypeId={processTypeId} processTypeStringId={processTypeStringId} />;
};

export default AssessmentQualificationPage;
